import { render, staticRenderFns } from "./bis.vue?vue&type=template&id=291606ce"
import script from "./bis.vue?vue&type=script&lang=ts"
export * from "./bis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports